export default __webpack_public_path__ + "media/we-offer.ea312310.png";